import React from 'react';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

const _symbol = Symbol && Symbol.for || String;

const $$data = _symbol('__WIRED_DATA__');

const _update = (p, n) => {
  const r = {};
  Object.keys(p).forEach(key => {
    const prev = p[key];
    const next = n[key];
    r[key] = next === undefined || !(key in n) ? prev : next;
  });
  return r;
};

const _set = (s, param) => {
  const nextParams = typeof param === 'function' ? param(s[$$data]) : param;
  s[$$data] = _update(s[$$data], nextParams);
};

const store = initialData => {
  const Context = React.createContext(initialData);
  const s = {
    set: d => _set(s, d),
    get: () => s[$$data],
    [$$data]: initialData,
    root: undefined,
    wire: (Component, storeToProps) => {
      const MC = React.memo(Component);
      const name = `Wired(${Component.displayName || Component.name || ''})`;
      const obj = {
        [name]: p => React.createElement(Context.Consumer, null, store => React.createElement(MC, _extends({}, storeToProps(store), p)))
      };
      obj[name].displayName = name;
      return obj[name];
    }
  };
  s.root = rootFor(Context, s);
  return s;
};

const rootFor = (Context, Store) => {
  var _temp;

  return _temp = class WiredRoot extends React.Component {
    constructor(...args) {
      super(...args);

      _defineProperty(this, "m", true);

      _defineProperty(this, "update", () => this.m && this.setState({
        s: Store[$$data]
      }));

      _defineProperty(this, "setStore", d => {
        _set(Store, d);

        this.update();
      });

      _defineProperty(this, "state", {
        s: Store[$$data]
      });

      _defineProperty(this, "componentDidMount", () => {
        Store.set = this.setStore;
        if (Store[$$data] !== this.state.s) this.update();
      });

      _defineProperty(this, "componentWillUnmount", () => {
        this.m = false;
      });

      _defineProperty(this, "render", () => React.createElement(Context.Provider, {
        value: this.state.s
      }, this.props.children));
    }

  }, _temp;
};

const Wired = {
  store
};

export { Wired };
